import { render, staticRenderFns } from "./tl-set-hard-disk-alarm-modal.vue?vue&type=template&id=aa4928aa"
import script from "./tl-set-hard-disk-alarm-modal.vue?vue&type=script&lang=js"
export * from "./tl-set-hard-disk-alarm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports